/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { ContactusPage } from './public/ContactusPage'
import { AboutusPage } from './public/AboutusPage'
import { TosPage } from './public/TosPage'
import { ProivacyPolicyPage } from './public/ProivacyPolicyPage'
import LoginPage from './public/LoginPage'
import DashboardPage from './guarded/DashboardPage'
import MainGuardRoute from '../guards/MainGuardRoute'
import RegisterPage from './public/RegisterPage'
import GuardedRoute from '../guards/GuardedRoute'
import AccountPage from './guarded/AccountPage'
import PostsPage from './guarded/postsPage'
import UsersPage from './guarded/UsersPage'
import ReportedPostsPage from './guarded/ReportedPosts'
import ReportedUsersPage from './guarded/ReportedUsers'
import NotificationPage from './guarded/NotificationPage'
import GuardedSignUpRoute from '../guards/GuardedSignUpRoute'


const Pages = () => {

  return (
    <Routes>
      <Route exact path="/" element={
        <MainGuardRoute />
      } />

      <Route exact path="/dashboard" element={
        <GuardedRoute>
          <DashboardPage />
        </GuardedRoute>
      } />
      <Route exact path="/manage-posts" element={
        <GuardedRoute>
          <PostsPage />
        </GuardedRoute>
      } />
      <Route exact path="/manage-users" element={
        <GuardedRoute>
          <UsersPage />
        </GuardedRoute>
      } />
      <Route exact path="/manage-reported-users" element={
        <GuardedRoute>
          <ReportedUsersPage />
        </GuardedRoute>
      } />
      <Route exact path="/manage-notifications" element={
        <GuardedRoute>
          <NotificationPage />
        </GuardedRoute>
      } />
      <Route exact path="/manage-reported-posts" element={
        <GuardedRoute>
          <ReportedPostsPage />
        </GuardedRoute>
      } />
      <Route exact path={"/account"} element={
        <GuardedRoute>
          <AccountPage />
        </GuardedRoute>
      } />
      <Route exact path="/login" element={
        <LoginPage />
      } />
      <Route exact path="/register" element={
        <GuardedSignUpRoute>

          <RegisterPage />
        </GuardedSignUpRoute>
      } />
      <Route exact path="/contact-us" element={
        <ContactusPage />
      } />
      <Route exact path="/about-us" element={
        <AboutusPage />
      } />
      <Route exact path="/tos" element={
        <TosPage />
      } />
      <Route exact path="/privacypolicy" element={
        <ProivacyPolicyPage />
      } />

    </Routes>
  )

}



export default Pages